<template>
    <div class="main">
        <div class="text-wrapper">
            <div class="flex flex-row justify-between self-stretch">
                <span>Upload and Attach Files</span>
            </div>
            <p>Upload and Attach Files to Your Message.</p>
        </div>
    </div>
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
.main {
    display: flex;
    padding: 24px 24px 20px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    .text-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        align-self: stretch;
    }

    span {
        color: var(--Gray-900, #181d27);
        font-family: Inter;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
    }

    p {
        color: var(--Gray-600, #535862);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
}
</style>
